/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Number_Of_VisitorsInputs */

const en_admin_external_booking_edit_number_of_visitors = /** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. of Visitors`)
};

const de_admin_external_booking_edit_number_of_visitors = /** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Besucher`)
};

const es_admin_external_booking_edit_number_of_visitors = /** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N.º de visitantes`)
};

const fr_admin_external_booking_edit_number_of_visitors = /** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nombre de visiteurs`)
};

const nl_admin_external_booking_edit_number_of_visitors = /** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aantal bezoekers`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */
const it_admin_external_booking_edit_number_of_visitors = en_admin_external_booking_edit_number_of_visitors;

/** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_number_of_visitors = en_admin_external_booking_edit_number_of_visitors;

/** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */
const pl_admin_external_booking_edit_number_of_visitors = en_admin_external_booking_edit_number_of_visitors;

/** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */
const hu_admin_external_booking_edit_number_of_visitors = en_admin_external_booking_edit_number_of_visitors;

/** @type {(inputs: Admin_External_Booking_Edit_Number_Of_VisitorsInputs) => LocalizedString} */
const ro_admin_external_booking_edit_number_of_visitors = en_admin_external_booking_edit_number_of_visitors;

/**
* | output |
* | --- |
* | "No. of Visitors" |
*
* @param {Admin_External_Booking_Edit_Number_Of_VisitorsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_number_of_visitors = /** @type {((inputs?: Admin_External_Booking_Edit_Number_Of_VisitorsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Number_Of_VisitorsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "de") return de_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "es") return es_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "it") return it_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_number_of_visitors(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_number_of_visitors(inputs)
	return ro_admin_external_booking_edit_number_of_visitors(inputs)
});
export { admin_external_booking_edit_number_of_visitors as "admin.external_booking_edit.number_of_visitors" }